import InsightsHome from './InsightsHome';

export default InsightsHome;
